import React, { Component } from 'react'

import database from '../config'
import getDate from '../helpers/getDate'

class AddDataForm extends Component {
  state = {
    url: '',
    email: '',
    password: '',
    passwordHaveUppercase: false,
    passwordHaveLowercase: false,
    passwordHaveSpecial: false,
    passwordHaveNum: false,
    passwordHaveValidLength: false
  }

  onChange = e => {
    if (e.target.name === 'password') {
      this.passwordHaveLowercase(e.target.value)
      this.passwordHaveNum(e.target.value)
      this.passwordHaveSpecial(e.target.value)
      this.passwordHaveUppercase(e.target.value)
      this.passwordHaveValidLength(e.target.value)
    }

    this.setState({
      [e.target.name]: e.target.value
    })
  }

  addData = () => {
    let obj = {
      url: this.state.url,
      email: this.state.email,
      password: this.state.password,
      user: this.props.user,
      createdAt: getDate(),
      updatedAt: getDate()
    }

    database.ref('/').push().set(obj)

    this.setState({
      url: '',
      email: '',
      password: ''
    })

    this.props.history.push('/')
  }

  passwordHaveUppercase = str => {
    if (str.match(/[A-Z]/)) {
      this.setState({
        passwordHaveUppercase: true
      })
    } else {
      this.setState({
        passwordHaveUppercase: false
      })
    }
  }

  passwordHaveLowercase = str => {
    if (str.match(/[a-z]/)) {
      this.setState({
        passwordHaveLowercase: true
      })
    } else {
      this.setState({
        passwordHaveLowercase: false
      })
    }
  }

  passwordHaveSpecial = str => {
    if (str.match(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) {
      this.setState({
        passwordHaveSpecial: true
      })
    } else {
      this.setState({
        passwordHaveSpecial: false
      })
    }
  }

  passwordHaveNum = str => {
    if (str.match(/\d/)) {
      this.setState({
        passwordHaveNum: true
      })
    } else {
      this.setState({
        passwordHaveNum: false
      })
    }
  }

  passwordHaveValidLength = str => {
    if (str.length > 5) {
      this.setState({
        passwordHaveValidLength: true
      })
    } else {
      this.setState({
        passwordHaveValidLength: false
      })
    }
  }

  render() {
    return (
      <div>
        <div className="container">
          <div className="mt-5">

            <div className="row pt-5">
              <div className="col-md-3"></div>
              <div className="col-md-6 text-center">
                  <h2>Add New Data</h2>
                  <hr/>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Alamat Website</label>
                <input type="text" className="form-control" name="url" aria-describedby="emailHelp" placeholder="http://facebook.com" autoComplete="off" value={this.state.url} onChange={this.onChange}/>
              </div>
            </div>
          
            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Email / Username</label>
                <input type="email" className="form-control" name="email" aria-describedby="emailHelp" placeholder="test@gmail.com" autoComplete="off" value={this.state.email} onChange={this.onChange}/>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Password</label>
                <input type="text" className="form-control" name="password" aria-describedby="emailHelp" placeholder="test123" autoComplete="off" value={this.state.password} onChange={this.onChange}/>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <button type="submit" className="btn btn-primary" onClick={this.addData}>Submit</button>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <h5>{ this.state.passwordHaveUppercase ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>  } Password harus memiliki setidaknya satu karakter huruf besar ( upper-case )</h5>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <h5>{ this.state.passwordHaveLowercase ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>  } Password harus memiliki setidaknya satu karakter huruf kecil ( lower-case )</h5>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <h5>{ this.state.passwordHaveSpecial ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>  } Password harus memiliki setidaknya satu karakter special ( !@#$%^... )</h5>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <h5>{ this.state.passwordHaveNum ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>  } Password harus memiliki setidaknya satu angka</h5>
              </div>
            </div>

            <div className="d-flex justify-content-center text-center">
              <div className="form-group">
                <h5>{ this.state.passwordHaveValidLength ? <i className="fas fa-check"></i> : <i className="fas fa-times"></i>  } Password harus memiliki panjang (length) lebih dari 5 karakter</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}


export default AddDataForm
